import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

import { CommonApiService } from '../../common-api.service';
import { SnackbarService } from '../../snackbar.service';
import { LoginService } from '../../login/login.service';
import { ProductionTransfer } from './production-transfer.interface';

@Component({
  selector: 'app-production-transfer',
  templateUrl: './production-transfer.component.html',
  styleUrls: ['./production-transfer.component.css'],
})
export class ProductionTransferComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  isAdmin = false;
  loading = false;
  rows: ProductionTransfer[] = [];
  total = 0;
  pageIndex = 0;
  pageSize = 10;
  displayedColumns = [
    'created_at',
    'job_no',
    'process',
    'from_employee',
    'to_employee',
    'transfer_reason',
  ];

  constructor(
    private api: CommonApiService,
    private router: Router,
    private snackbar: SnackbarService,
    private auth: LoginService,
  ) {}

  ngOnInit(): void {
    const cu: any = this.auth.currentUserValue;
    this.isAdmin = !!cu?.user?.admin;
    if (!this.isAdmin) {
      this.snackbar.error('Only an administrator can view production transfers');
      return;
    }
    this.loadList();
  }

  loadList(): void {
    this.loading = true;
    const params = {
      offset: this.pageIndex,
      limit: this.pageSize,
      sort: 'id:0',
      filterCriteria: [],
    };
    this.api.postAll('production-transfer/list/display', params).subscribe({
      next: (res: any) => {
        this.rows = res?.items || [];
        this.total = res?.rowCount || 0;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.snackbar.error(err?.error?.message || 'Failed to load transfers');
      },
    });
  }

  onPage(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadList();
  }

  refresh(): void {
    this.pageIndex = 0;
    if (this.paginator) {
      this.paginator.firstPage();
    }
    this.loadList();
  }

  openCreate(): void {
    this.router.navigate(['/production-transfer/create']);
  }
}
